module.exports = __webpack_public_path__ + "img/home_hero.ca456fe5.jpg";